import {Observable, Subject} from "rxjs";
import {FUINavigationBranch, FUINavigationLink, FUINavigationLoader, FUINavigationTree} from "@fedeltapointofsale/ui";
import {
    CustomReportConfigSearchModel
} from "../reports/custom-reports/custom-report-config/custom-report-config-search.model";
import {CustomReportConfigSearchData} from "../reports/custom-reports/custom-report-config/custom-report-config.data";
import {HttpClient} from "@angular/common/http";

export class NavigationLoader implements FUINavigationLoader {

    constructor(private httpClient: HttpClient, private customReportSearchModel: CustomReportConfigSearchModel) {
    }

    loadNavigation(): Observable<FUINavigationTree[]> {
        const subject: Subject<FUINavigationTree[]> = new Subject<FUINavigationTree[]>();

        this.httpClient.get("assets/navigator/navigator.json").subscribe((trees: Object[]) => {
            const navigationTrees: FUINavigationTree[] = trees.map(tree => new FUINavigationTree(tree));
            this.customReportSearchModel.search().subscribe({
                next: () => {
                    if (this.customReportSearchModel.data.length) {
                        const reportingTree: FUINavigationTree = navigationTrees.find(tree => tree.title === "wbo.navigator.reporting");
                        if (reportingTree) {
                            const reportsBranch: FUINavigationBranch = reportingTree.branches.find(tree => tree.title === "wbo.navigator.reports");
                            if (reportsBranch) {
                                const customReportsLink: FUINavigationLink = new FUINavigationLink({
                                    title: "wbo.navigator.custom-reports",
                                    links: []
                                });
                                reportsBranch.links.push(customReportsLink);
                                this.customReportSearchModel.data.forEach((customReport: CustomReportConfigSearchData) => {
                                    customReportsLink.links.push(new FUINavigationLink({
                                        title: "'" + customReport.formattedName + "'",
                                        href: "custom-report/" + customReport.id
                                    }));
                                });
                            }
                        }
                    }
                    subject.next(navigationTrees);
                },
                error: (error: any) => {
                    console.log("Failed to search for custom reports: " + error.toString());
                    subject.next(navigationTrees);
                }
            });
        });


        return subject;
    }
}
